import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { ILabel, ILabels, ISearchLabel, LabelHub } from '@bixi/label-angular';
import { groupBy } from '@mining/ui/core/util';
import { IETreeExpand, IMPageResult } from './typing';
import { getCount, getStyle, getWholeKeys } from './utils';

const formatResult = (labels: ISearchLabel[]): IMPageResult[] => {
  if (!labels.length) {
    return [];
  }
  const result = groupBy(labels, 'pageNumber');
  return Object.keys(result).map(key => {
    const content = result[key];
    return {
      name: `第${key}页`,
      children: Array.from(content, (child: ISearchLabel) => {
        return {
          ...child
        };
      })
    };
  });
};
@Component({
  selector: 'm-sidebar-menu-search',
  template: `
    <m-sidebar-menu-header mHeaderTitle="搜索" (mOpenChange)="onOpenAll()" (mCloseChange)="onCloseAll()"></m-sidebar-menu-header>
    <div class="m-sidebar-menu-search-container">
      <label nz-checkbox [(ngModel)]="caseSensitive" class="m-sidebar-menu-search-checkbox">区分大小写</label>
      <nz-input-group [nzPrefix]="prefixSearch" class="m-sidebar-menu-search-input">
        <input #inputRef type="text" nz-input placeholder="输入关键字" [value]="keyword" (keyup.enter)="onSearch(inputRef)" />
      </nz-input-group>
      <ng-template #prefixSearch><i nz-icon nzType="search" (click)="onSearch(inputRef)"></i></ng-template>
      <div class="m-sidebar-menu-search-result" *ngIf="keyword">共找到 {{ count }} 个结果</div>
      <div class="m-sidebar-menu-search-list" *ngIf="!mLoading; else loadingRef">
        <ng-container *ngIf="trees.length; else emptyResult">
          <ng-container *ngFor="let tree of trees; let idx = index">
            <div class="m-sidebar-menu-search-tree-title m-sidebar-menu-search-tree-item" (click)="onParentClick(tree)">
              <div class="m-sidebar-menu-search-tree-title-left">
                <i nz-icon [nzType]="expandKeys.includes(tree.name!) ? 'caret-down' : 'caret-right'" nzTheme="outline"></i>
                {{ tree.name }}
              </div>
              <div>（{{ tree.children!.length }}）</div>
            </div>
            <ng-container *ngIf="expandKeys.includes(tree.name!)">
              <ng-container *ngFor="let item of tree.children">
                <div class="m-sidebar-menu-search-tree-item m-sidebar-menu-search-tree-leaf" (click)="onLeafClick(item)">
                  <span>{{ item.prefix }}</span>
                  <span class="m-sidebar-menu-search-hightlight-word">{{ keyword | mTextEllipsis: 6 }}</span>
                  <span>{{ item.suffix }}</span>
                </div>
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #emptyResult>
          <nz-empty></nz-empty>
        </ng-template>
      </div>
      <ng-template #loadingRef>
        <div class="m-sidebar-menu-search-loading">
          <nz-spin nzSimple [nzIndicator]="cutomeLoading" nzSize="large"></nz-spin>
          <ng-template #cutomeLoading><i nz-icon nzType="loading"></i></ng-template>
        </div>
      </ng-template>
    </div>
  `,
  host: {
    class: 'm-sidebar-menu-search'
  }
})
export class MSidebarMenuSearchComponent {
  caseSensitive = true;
  @Input() mHub!: LabelHub;
  @Input() mLoading: boolean = false;
  @Input()
  set mOpen(value: IETreeExpand) {
    if (value === IETreeExpand.open) {
      this.expandKeys = this.wholeExpand;
    } else if (value === IETreeExpand.close) {
      this.expandKeys = [];
    }
  }

  @Output() readonly mSearchChange = new EventEmitter<ILabels>();
  @Output() readonly mClick = new EventEmitter<ILabel>();

  keyword = '';
  count = 0;
  allLabels: ILabels = [];
  trees: IMPageResult[] = [];
  expandKeys: string[] = [];
  wholeExpand: string[] = [];

  constructor(private cdr: ChangeDetectorRef) {}

  onSearch(ref: HTMLInputElement): void {
    this.keyword = ref.value;
    if (this.keyword) {
      this.mOpen = IETreeExpand.close;
      this.mLoading = true;
      this.mHub
        .search({
          keyword: this.keyword,
          caseSensitive: this.caseSensitive
        })
        .subscribe(result => {
          this.mLoading = false;
          const allLabels = result.map(label => ({ ...label, ...getStyle() }));
          this.trees = formatResult(result);
          this.count = getCount(this.trees);
          this.wholeExpand = getWholeKeys(this.trees);
          this.mSearchChange.emit(allLabels);
          this.cdr.detectChanges();
        });
    } else {
      this.trees = [];
      this.count = 0;
    }
  }

  onParentClick(item: IMPageResult): void {
    const name = item.name;
    const open = !this.expandKeys.includes(name!.toString());
    if (open) {
      this.expandKeys.push(name!.toString());
    } else {
      this.expandKeys = this.expandKeys.filter((i: string) => {
        return name !== i;
      });
    }
    this.cdr.detectChanges();
  }

  onLeafClick(item: IMPageResult): void {
    this.mClick.emit(item as ILabel);
  }

  onCloseAll(): void {
    this.mOpen = IETreeExpand.close;
  }

  onOpenAll(): void {
    this.mOpen = IETreeExpand.open;
  }
}
